/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { date, DateFormat, entity, enumeration } from '@gh/core-data';
import {
  TodoChangeStatusRequestDto,
  TodoChangeStatusResponseDto,
  TodoDetailsDto,
  TodoListDto,
  TodoStatus,
} from './todo.dto';

export const TodoListMapper = entity<TodoListDto>({
  dueDate: date(DateFormat.DateTime),
});

export const TodoDetailsMapper = entity<TodoDetailsDto>({
  status: enumeration(TodoStatus),
  dueDate: date(DateFormat.DateTime),
});

export const TodoChangeStatusRequestMapper = entity<TodoChangeStatusRequestDto>();
export const TodoChangeStatusResponseMapper = entity<TodoChangeStatusResponseDto>();
